import React from "react";

function BookList() {
  return (
    <div style={{ padding: '20px' }}>
      <h1 className="text-2xl font-bold text-center mb-4">List of Books Prescribed</h1>
      <p className="text-center mt-4">
        <a
          href="/documents/BookList.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xl font-bold text-purple-700 underline hover:text-purple-900"
        >
          CLICK HERE TO SEE THE LIST OF BOOKS
        </a>
      </p>
    </div>
  );
}

export default BookList;